<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                <v-row class="px-5 pt-5">
                    <v-col cols="12" align="center" justify="center">    
                        <h2 class="blue_accent--text text-uppercase">{{ $t('order_incidence.incidence_on_return') }}</h2>
                    </v-col>
                </v-row>
                <v-card-text class="px-0">
                    <v-form ref="form" lazy-validation @submit.prevent="save">
                       <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="order.unique_order_number" :label="$t('order_incidence.uon')" :rules="rules_required" disabled></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-text-field class="py-0" v-model="order.shipment_number" :label="$t('order_incidence.shipping_number')" :rules="rules_required" disabled></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <label style="font-size: 13px; font-weight: bold;" class="blue_accent--text">{{$t('order_incidence.warning')}}</label>
                            </v-col>
                        </v-row>
                        <v-row class="px-5 py-0 my-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <datatable 
                                    :props="{headers: headers, items: order.details}" 
                                    :stolen_editable="true"
                                    :damaged_editable="true"
                                    @methodHandler="methodHandler"></datatable>
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-row class="px-5 py-0" justify="center">
                        <v-col cols="6" align="end" justify="end">
                            <v-btn class="right px-3 mx-4" @click="cancel" >
                                {{ $t('order_incidence.cancel') }}
                            </v-btn>
                            <v-btn class="right white_highlight--text" color="secondary" @click="save" >
                                {{ $t('order_incidence.save') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
        </v-container>        
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>
import { getDetailOrderReturnedUseCase } from "../../shared/application/use_cases/get_detail_order_returned_use_case";
import { updateDetailOrderReturnedUseCase } from "../../shared/application/use_cases/update_detail_order_returned_use_case";
import { HttpOrderReturnedRepository } from "../../shared/infrastructure/repositories/order_returned_repository";

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]},
        headers(){
            return [
                { text: this.$t('order_incidence.sku'), value: 'sku' },
                { text: this.$t('order_incidence.quantity'), value: 'total_quantity' },
                { text: this.$t('order_incidence.damaged_product'), value: 'damaged_product' },
                { text: this.$t('order_incidence.stolen_product'), value: 'stolen_product' },
                { text: this.$t('order_incidence.incidence_date'), value: 'date' }
            ]
        } 
    },
    data(){
        return {
            order_id: this.$route.params.id,
            type: this.$route.params.type,
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            search: '',
            incidence_types: ["Producto dañado", "Producto perdido/robado"],
            order: {
                unique_order_number: '',
                shipment_number: '',
                products:[]
            },
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers."+ this.type +"_returns_incidences";
    },
    methods: {
        async index(){
            try {
                const result = await getDetailOrderReturnedUseCase(this.order_id, HttpOrderReturnedRepository);
                this.order = result;
            } 
            catch (e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        methodHandler(object){
            this[object.methodName](object.parameters);
        },
        async save(){
            try {
                const result = await updateDetailOrderReturnedUseCase(this.order, HttpOrderReturnedRepository);
                this.order = result;    
                
                this.snackbar = {
                    visible: true,
                    color: 'success2',
                    text: result.data.success.message
                }
                
                this.$router.go(-1);  

            } catch (e) {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e
                }
            }
        },
        cancel(){
            this.$router.go(-1);
        },
    },
    watch:{
    }
}
</script>

<style lang="css">
</style>